__turbopack_context__.v({
  "contentContainer": "ContentPage-module-scss-module__-ZV2aq__contentContainer",
  "contentContainerNoContent": "ContentPage-module-scss-module__-ZV2aq__contentContainerNoContent",
  "contentNavCloseButton": "ContentPage-module-scss-module__-ZV2aq__contentNavCloseButton",
  "contentPageChildLinks": "ContentPage-module-scss-module__-ZV2aq__contentPageChildLinks",
  "contentPageContent": "ContentPage-module-scss-module__-ZV2aq__contentPageContent",
  "contentPageHeading": "ContentPage-module-scss-module__-ZV2aq__contentPageHeading",
  "contentPageHeadingNoHero": "ContentPage-module-scss-module__-ZV2aq__contentPageHeadingNoHero",
  "contentPageNavFlyout": "ContentPage-module-scss-module__-ZV2aq__contentPageNavFlyout",
  "contentPageSideBar": "ContentPage-module-scss-module__-ZV2aq__contentPageSideBar",
  "mobileNavigationButton": "ContentPage-module-scss-module__-ZV2aq__mobileNavigationButton",
  "navigationDesktop": "ContentPage-module-scss-module__-ZV2aq__navigationDesktop",
  "recentBlogsContainer": "ContentPage-module-scss-module__-ZV2aq__recentBlogsContainer",
});
